import React from "react";
import { Link } from "react-router-dom";
import BlogBoxHome from "./BlogBoxHome";
import { useAuth } from "../../Store/AuthContext";
import { BlogLimitData } from "../../APIS/FetchAPIs";

export default function BlogSectionHome() {
  const { RendomTokenfetch } = useAuth();
  const [LatestBlogLimit, loading] = BlogLimitData(RendomTokenfetch);
  return (
    <>
      <section className="news-section section-padding fix   section-bg">
        <div className="container">
          <div className="section-title-area">
            <div className="section-title">
              {/* <h5 className="wow fadeInUp">
                <i className="fa fa-angle-double-left" aria-hidden="true"></i>{" "}
                LATEST UPDATE{" "}
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
              </h5> */}
              <h2
                className="wow fadeInUp aboutSectiontitle"
                data-wow-delay=".3s"
              >
                Real Estate Developers News
              </h2>
            </div>
            <Link
              to="/blogs"
              className="theme-btn wow fadeInUp"
              data-wow-delay=".4s"
            >
              View All Blog
            </Link>
          </div>
          <div className="row">
            {loading ? (
              <p className="text-center">Loading blogs...</p>
            ) : LatestBlogLimit.length > 0 ? (
              LatestBlogLimit.map((val) => (
                <BlogBoxHome key={val.id || val._id} blogdata={val} />
              ))
            ) : (
              <p className="text-center">No blogs available right now.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
